<template>
  <div class="custom-language">
    <div
      class="text-center"
      v-if="languages && languages.length > 1"
      style="padding: 10px;"
    >
      <a
        v-for="(item,i) in languages"
        :key="i"
        style="font-size: 18px !important;color: white;"
        @click.stop.prevent="handleChangeLocale(item.ID)"
      >
        <span
          :style="{'font-weight': item.ID === locale ? 'bold' : 'normal'}"
        >
          {{ item.Name.split('-')[0].toUpperCase() }}
        </span>
        <span
          v-if="i+1 < languages.length"
        >
          {{ ' | ' }}
        </span>
      </a>
    </div>
    <!-- <back-button /> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import utils from '@/services/utils'
  // import BackButton from '@/components/BackButton'
  export default {
    components: {
      // BackButton
    },
    computed: {
      ...mapState('app',['Languages', 'locale']),
      languages () {
        return utils.getAllLanguages(this.Languages)
      }
    },
    methods: {
      handleChangeLocale (id){
        localStorage.setItem('locale',id)
        this.$store.state.app.locale = id
      }
    }
  }
</script>
<style lang="postcss" scoped>
  .custom-language {
    padding-top: 20px;
    padding-bottom: 10px;
    width: 100%;
    background-image: linear-gradient(to top, rgba(128, 128, 128, 0), rgba(0, 0, 0, 0.5));
  }
</style>
